import React from "react";
function Contact() {
  const hoverOnContact = (e) => {
    let theContact = e.target;
    console.log(theContact.innerHTML);
  };

  return (
    <div id="Contact" className=".all">
      <div id="contact_title">
        <h1>Contact</h1>
      </div>

      <div class="contact_container_flex">
        <div class="contact_container">
          <a
            href="https://www.instagram.com/makosi_sports/?hl=fr"
            target="_blank"
            class="Logos"
          ></a>
          <a
            href="https://www.instagram.com/makosiprod/?hl=fr"
            target="_blank"
            class="Logos"
          ></a>
          <a
            href="https://www.linkedin.com/in/ina-thiam-b13bb5281/"
            target="_blank"
            class="Logos"
          ></a>
          {/* <a class="Logos"></a> */}
        </div>
      </div>
      <div id="tel_gMail">
        Mail: makosiprod@gmail.com / ina.nfthiam@gmail.com /
        makosi.sports@gmail.com
        <br />
        Tel: +221 76 611 75 08
      </div>
    </div>
  );
}

export default Contact;
